import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  CreatePromoCodePayload,
  CreatePromoCodeResponse,
} from 'models/PromoCode';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<{}, BaseErrorResponse, CreatePromoCodePayload>,
  'mutationFn' | 'mutationKey'
>;

const useCreatePromoCode = ({ ...options }: ReactQueryMutationOptions = {}) => {
  const { mutateAsync: createPromoCode, isLoading } = useAppMutation({
    mutationFn: (payload: CreatePromoCodePayload) =>
      API.post<CreatePromoCodeResponse>('/api/v3.2/promo-codes', payload),
    ...options,
  });

  return { createPromoCode, isLoading };
};

export default useCreatePromoCode;
